import { render, staticRenderFns } from "./MentorRole.vue?vue&type=template&id=b3e3bd02&scoped=true&"
import script from "./MentorRole.vue?vue&type=script&lang=js&"
export * from "./MentorRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e3bd02",
  null
  
)

export default component.exports